












import GetDeviceQuery from '@/graphql/queries/getDevice.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';
import MessageDisplay from '@/components/MessageDisplay.vue';
import DeviceInfoDisplay from '@/components/DeviceInfoDisplay.vue';
import IDevice from '../interfaces/device';
import IMessage from '@/interfaces/message';

@Component({
  components: {
    DeviceInfoDisplay,
    MessageDisplay,
  },
})
export default class Device extends Vue {
  public device: IDevice = Object();
  public newNickname = '';
  public isNameBeingChanged = false;
  public errorMessage = '';
  public messages: IMessage[] = [];
  public deviceId = '';

  public mounted() {
    const deviceId = this.$route.params.id;

    if (deviceId != null) {
      request(GetDeviceQuery as any, { id: deviceId })
        .then(({ data }) => {
          this.device = data.getDevice;
          if (this.device.messages !== undefined) {
            this.messages =
              this.device.messages.sort((a: IMessage, b: IMessage) => {
                return (
                  new Date(b.timestamp).valueOf() -
                  new Date(a.timestamp).valueOf()
                );
              });
          }

          this.newNickname = this.device.nickname;
        })
        .catch(error => {
          // TODO: Error handling
        });
    }
  }
}
